import BaseTemplate from '../../src/layouts/BaseTemplate'
import ForgotPasswordView from '@/kyna/view/_public/ForgotPasswordView';

import React, { Component } from 'react';

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.usernameRef = React.createRef()
  }

  componentDidMount = () => {
    // console.log("didmount")
    // this.usernameRef.focus()
  }

  render() {
    return (
      <BaseTemplate title="Forgot Password" body={<ForgotPasswordView {...this.props} setRef={this.usernameRef} />} />
    );
  }
}